
export const removeFirstObj = (array: Array<any>) => {
  let e = [...array];
  return e.filter((item, i) => i !== 0);
}


export const returnLimitedWords = (string: string, num: number) => {
  if (string.length > num) { string = string.substring(0, num) + '...' };
  return string;
}

export const NepaliNS = (number: string | number, symbol: string = '') => {
  const string = number?.toString()
  if (string === 'NaN') {
    //quick fix----this needs to be managed properly...
    return ''
  }
  if (string?.length > 3) {
    let hundredPlace = string.substring(string.length - 3)
    let remaining = string.slice(0, -3)
    remaining = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",")
    return symbol + ' ' + remaining + ',' + hundredPlace
  }
  return symbol + ' ' + number
}



export const setFormdata = (data: any) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => {
    formData.append(key, data[key]);
  })
  return formData;

}


export const routeFormatter = (text: string) => {
  if (text.charAt(0) === '/') {
    return text;
  }
  return '/' + text;
}


// set side bar contents

export const DvNumber = (number: string) => {
  const dev = 2406;
  const zero = 48; // char code for Arabic zero
  const nine = 57; // char code for Arabic nine

  let output = number.toString().split("");
  let offset = dev - zero;

  for (let i = 0; i < output.length; i++) {
    let cc = output[i].charCodeAt(0);
    if (cc >= zero && cc <= nine) {
      output[i] = String.fromCharCode(cc + offset);
    }
  }
  return output.join("");
}
